/* Ellada : option emballage cadeau du panier (attribut de panier). */
(function () {
  if (window.elladaCart) return;
  window.elladaCart = true;
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-ellada-cadeau]');
    if (!input) return;
    var attributs = {};
    attributs[input.dataset.attribut] = input.checked ? 'Oui' : '';
    input.disabled = true;
    fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributs })
    })
      .catch(function () {
        input.checked = !input.checked;
      })
      .finally(function () {
        input.disabled = false;
      });
  });
})();

/* Ellada : ajout en un clic des suggestions du tiroir panier (sans formulaire imbrique). */
(function () {
  if (window.elladaSuggestion) return;
  window.elladaSuggestion = true;
  document.addEventListener('click', function (event) {
    var bouton = event.target.closest('[data-ellada-add]');
    if (!bouton) return;
    event.preventDefault();
    if (bouton.getAttribute('aria-disabled') === 'true') return;
    bouton.setAttribute('aria-disabled', 'true');
    bouton.classList.add('loading');
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(racine + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(bouton.dataset.elladaAdd),
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (reponse) { return reponse.json(); })
      .then(function (data) {
        if (data.status) {
          console.error(data.description || data.message);
          return;
        }
        if (drawer && drawer.renderContents) {
          drawer.renderContents(data);
        } else {
          window.location.href = racine + 'cart';
        }
      })
      .catch(function (erreur) {
        console.error(erreur);
      })
      .finally(function () {
        bouton.removeAttribute('aria-disabled');
        bouton.classList.remove('loading');
      });
  });
})();
